import { render, staticRenderFns } from "./Cxc.vue?vue&type=template&id=8b736f6e&scoped=true"
import script from "./Cxc.vue?vue&type=script&lang=js"
export * from "./Cxc.vue?vue&type=script&lang=js"
import style0 from "./Cxc.vue?vue&type=style&index=0&id=8b736f6e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b736f6e",
  null
  
)

export default component.exports